import { useState } from 'react'

const contentBlock = {
  display: 'flex',
  flexDirection: 'column',
  gap: 12
}

const sectionTitle = {
  fontSize: 16,
  fontWeight: 700,
  marginTop: 4
}

const tripsChartWrap = {
  background: '#fff',
  border: '1px solid #d4d4d4',
  borderRadius: 10,
  padding: '12px 10px 6px 10px',
  minHeight: 300,
  position: 'relative'
}

const tripsGrid = {
  position: 'absolute',
  inset: '12px 10px 30px 10px',
  pointerEvents: 'none'
}

const tripGridLine = {
  position: 'absolute',
  left: 46,
  right: 8,
  borderTop: '1px solid #e8e8e8'
}

const tripGridLabel = {
  position: 'absolute',
  left: -44,
  top: -8,
  fontSize: 14,
  color: '#666'
}

const tripBarsRow = {
  height: 276,
  display: 'flex',
  alignItems: 'flex-end',
  position: 'absolute',
  inset: '12px 10px 30px 10px',
  paddingLeft: 48,
  paddingRight: 8,

  zIndex: 1,
  overflow: 'visible'
}

const tripBarGroup = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flex: 1,
  minWidth: 0,
  height: '100%',
  justifyContent: 'flex-end',
  position: 'relative'
}

const tripBarStack = {
  width: '100%',
  maxWidth: 60,
  height: '100%',
  borderRadius: 6,
  overflow: 'visible',
  display: 'flex',
  flexDirection: 'column-reverse'
}

const tripBarSegment = {
  width: '100%'
}

const tripBarLabel = {
  position: 'absolute',
  top: '100%',
  marginTop: 6,
  fontSize: 14,
  textTransform: 'capitalize'
}

const tripsLegendWrap = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 10,
  marginTop: 10
}

const tripLegendItem = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: 13,
  background: '#fff',
  border: '1px solid #d4d4d4',
  borderRadius: 8,
  padding: '4px 8px',
  cursor: 'pointer'
}

const tripLegendColor = {
  width: 12,
  height: 12,
  borderRadius: 2
}

const StatsTripsModal = ({ stats, t, fmtNum }) => {
  const [tooltip, setTooltip] = useState(null)
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 })
  const [multiTooltips, setMultiTooltips] = useState([])

  return (
    <>
      <div style={contentBlock}>
<div style={sectionTitle}>
  {t('TRIPLOG.STATISTICS.TRIPS.TITLE')}{' '}
  <span style={{ color: '#107c6b', fontWeight: 700 }}>
    {stats.tripsPeriodText}
  </span>
</div>

        <div style={tripsChartWrap}>
          <div style={tripsGrid}>
            {stats.tripsTicks.map((tick) => {
              const yPercent = 100 - ((tick / stats.tripsMaxValue) * 100)
              return (
                <div key={tick} style={{ ...tripGridLine, top: `${yPercent}%` }}>
                  <span style={tripGridLabel}>{fmtNum(tick, 0)}</span>
                </div>
              )
            })}
          </div>

          <div style={tripBarsRow}>
            {stats.tripsChartData.map((month) => (
              <div key={month.month} style={tripBarGroup}>
                <div style={tripBarStack}>
                  {month.segments.map((segment) => (
                    <div
                      key={`${month.month}-${segment.vehicleId}`}
                      data-vehicle-id={segment.vehicleId}
                      data-value={segment.value}
                      onMouseEnter={(e) => {
                        const vehicle = stats.tripsLegend.find(
                          v => String(v.vehicleId) === String(segment.vehicleId)
                        )

                        const plate = vehicle?.licensePlate ? ` (${vehicle.licensePlate})` : ''

                        setTooltip(
                          `${segment.label}${plate} • ${fmtNum(segment.value, 2)} ${t('TRIPLOG.UNITS.KM')}`
                        )

                        setCursorPos({ x: e.clientX, y: e.clientY })
                      }}
                      onMouseLeave={() => setTooltip(null)}
                      onMouseMove={(e) => setCursorPos({ x: e.clientX, y: e.clientY })}
                      style={{
                        ...tripBarSegment,
                        height: `${segment.heightPercent}%`,
                        backgroundColor: segment.color,
			  borderRadius: 4
                      }}
                    />
                  ))}
                </div>
                <div style={tripBarLabel}>{month.monthLabel}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={tripsLegendWrap}>
          {stats.tripsLegend.map((legendItem) => (
            <div
              key={legendItem.vehicleId}
              style={tripLegendItem}
              onMouseEnter={() => {
                const elements = document.querySelectorAll(
                  `[data-vehicle-id="${legendItem.vehicleId}"]`
                )

                const newTooltips = []

                elements.forEach((el) => {
                  const rect = el.getBoundingClientRect()
                  const value = el.getAttribute('data-value')

                  const plate = legendItem.licensePlate ? ` (${legendItem.licensePlate})` : ''

                  newTooltips.push({
                    x: rect.left + rect.width / 2,
                    y: rect.top + rect.height / 2,
                    text: `${legendItem.label}${plate} • ${fmtNum(value, 2)} ${t('TRIPLOG.UNITS.KM')}`
                  })
                })

                setMultiTooltips(newTooltips)
              }}
              onMouseLeave={() => setMultiTooltips([])}
            >
              <span style={{ ...tripLegendColor, backgroundColor: legendItem.color }} />
              <span>
                {legendItem.label}
                {legendItem.licensePlate ? ` (${legendItem.licensePlate})` : ''}
              </span>
            </div>
          ))}
        </div>
      </div>

      {tooltip && (
        <div
          style={{
            position: 'fixed',
            top: cursorPos.y - 50,
            left: cursorPos.x,
            transform: 'translateX(-50%)',
            background: 'rgba(0,0,0,0.85)',
            color: '#E7DFEC',
            padding: '5px 12px',
            borderRadius: 10,
            fontSize: 14,
            pointerEvents: 'none',
            zIndex: 5000
          }}
        >
          {tooltip}
        </div>
      )}

      {[...multiTooltips]
        .sort((a, b) => a.y - b.y)
        .map((tt, i, arr) => {
          let y = tt.y

          if (i > 0) {
            const prev = arr[i - 1]
            if (y - prev._finalY < 24) {
              y = prev._finalY + 24
            }
          }

          tt._finalY = y

          return (
            <div
              key={i}
              style={{
                position: 'fixed',
                top: y,
                left: tt.x,
                transform: 'translate(-50%, -50%)',
                background: 'rgba(0,0,0,0.85)',
                color: '#E7DFEC',
                padding: '4px 7px',
                borderRadius: 8,
                fontSize: 12,
                lineHeight: 1.1,
                pointerEvents: 'none',
                zIndex: 5000,
                whiteSpace: 'nowrap'
              }}
            >
              {tt.text}
            </div>
          )
        })}
    </>
  )
}

export default StatsTripsModal